// extracted by mini-css-extract-plugin
export default {"unpause":"UnpauseBtn_unpause__XbQqD","btnAnimation":"UnpauseBtn_btnAnimation__44V31","unpause__G":"UnpauseBtn_unpause__G__zDE5i","unpause__P":"UnpauseBtn_unpause__P__rvGEE"};